<template>
    <div style="display:flex;height:100%;">
        <div class="left-tree">
            <div style="background:#4A4C4F;padding:10px 5px;">
                <span>站点导航</span>
                <i class="el-icon-search" @click="showSearch" style="padding-left:15px;" v-if="!isFold"></i>
                <span style="display:inline-block;" @click="toggle">
                    <i :class="[isFoldClass]"></i>
                </span>
            </div>
            <el-input v-if="showSearchBox" clearable
                placeholder="输入关键字进行过滤"
                v-model="filterText">
            </el-input>
            <div class="tree-div">
                <tree :type="'site'" :data="treeData"
                  @clickNode="clickNode"
                  @clickMark="clickMark"
                  :currentKey="currentKey"
                  :isDefaultExpandFirst = "isDefaultExpandFirst"
                  ref="trees"
                  v-if="treeData.length!=0"></tree>
            </div>
        </div>
        <div class="main-area">
            <div class="sub-tabs site-tabs">
                <div>
                    <!--<button class="small-btn" @click="handleSelectAll(3)">全选</button>-->
                </div>
                <el-tabs v-model="activeTab" class="site-tabs-ul">
                    <el-tab-pane label="报告列表" name="list"></el-tab-pane>
                </el-tabs>
            </div>
            <div v-if="activeTab == 'list'" style="height:calc(100% - 50px);">
                <div class="search-content">
                <el-form ref="from" :model="searchForm" label-width="80px" class="site-form">
                    <el-col :span="18">
                        <el-col :span="14">
                            <el-form-item label="统计范围" required>
                                <el-date-picker v-model="dataRange" @change="selectDate" type="datetimerange"
                                    start-placeholder="开始日期" end-placeholder="结束日期" clearable :class="{ 'selected-border':  dataRange && dataRange.length === 2 }">
                                </el-date-picker>
                            </el-form-item>
                        </el-col>
                    </el-col>    
                    <el-col :span="18">
                        <!--<el-col :span="12">
                            <el-form-item label="公司名称" prop="point_name">
                                <el-input v-model="form.point_name"  placeholder="请输入关键字" clearable style="width:217px;"  :class="{ 'selected-border': form.point_name }"></el-input>
                            </el-form-item>
                        </el-col>-->
                        <el-col :span="8">
                            <el-form-item label="站点名称" prop="point_name">
                                <!--<el-input v-model="form.point_name"  placeholder="请输入关键字" clearable style="width:217px;"  :class="{ 'selected-border': form.point_name }"></el-input>-->
                                <el-select
                                v-model="searchForm.site_ids"
                                placeholder="请选择站点"
                                class="form-control"
                                multiple
                                collapse-tags
                                collapse-tags-tooltip
                                clearable
                                :class="{ 'selected-border': searchForm.site_ids.length > 0 }"
                                >
                                <el-option
                                    v-for="item in siteList"
                                    :key="item._id"
                                    :label="item.name"
                                    :value="item._id"
                                ></el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :span="8">
                            <el-form-item label="状态" prop="point_name">
                                <!--<el-input v-model="form.point_name"  placeholder="请输入关键字" clearable style="width:217px;"  :class="{ 'selected-border': form.point_name }"></el-input>-->
                                <el-select
                                v-model="searchForm.status"
                                placeholder="请选择状态"
                                class="form-control"
                                clearable
                                :class="{ 'selected-border': searchForm.status }"
                                >
                                <el-option
                                    v-for="item in statusList"
                                    :key="item.value"
                                    :label="item.name"
                                    :value="item.value"
                                ></el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :span="8">
                            <el-form-item label="报告等级" prop="report_level">
                                <el-select
                                v-model="searchForm.report_level"
                                placeholder="请选择报告等级"
                                class="form-control"
                                clearable
                                :class="{ 'selected-border': searchForm.report_level }"
                                >
                                <el-option label="站点级别" :value="0"></el-option>
                                <el-option label="公司级别" :value="1"></el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                    </el-col>
                    <el-col :span="6">
                        <el-form-item size="large">
                            <el-button class="small-btn" @click="queryData">查询</el-button>
                            <el-button class="small-btn" @click="doReset">重置</el-button>
                            <el-button class="small-btn" @click="dialogVisible = true">生成报告</el-button>
                            <!--<el-button type="primary" @click="showReportDialog = true">预览</el-button>-->
                        </el-form-item>
                    </el-col>
                </el-form>
            </div>

            <div class="table-content">
                <el-table :data="reportList"
                    highlight-current-row
                    style="width: 100%"
                    @selection-change="handleSelectionChange"
                    @select--all="handleSelectAll"
                    row-key="id"
                    :reserve-selection="true"
                    v-loading="loading"
                    element-loading-text="拼命加载中"
                    element-loading-spinner="el-icon-loading"
                    element-loading-background="rgba(0, 0, 0, 0.8)" ref="multipleTable">
                    <!--<el-table-column
                        header-align="center"
                        align="center"
                        type="selection" :selectable="selectFun"
                        width="55"
                    ></el-table-column>-->
                    <el-table-column label="序号" align="center" type="index" width="50"></el-table-column>
                    <el-table-column prop="customer_name" align="center" label="公司名称" min-width="180" show-overflow-tooltip></el-table-column>
                    <el-table-column prop="site_name" align="center"  label="站点名称" min-width="180" show-overflow-tooltip>
                        <template slot-scope="props">
                           {{ props.row.site_name || '所有站' }}
                        </template>
                    </el-table-column>
                    <el-table-column prop="report_level" align="center" min-width="120" label="报告等级" show-overflow-tooltip>
                        <template slot-scope="props">
                           {{ props.row.report_level == 1? "公司级别" : "站点级别" }}
                        </template>
                    </el-table-column>
                    <el-table-column prop="only_alarm_data" align="center" min-width="70" label="仅报警" show-overflow-tooltip>
                        <template slot-scope="props">
                           {{ props.row.only_alarm_data == false? "否" : "是" }}
                        </template>
                    </el-table-column>
                    <el-table-column prop="" align="center" min-width="300" label="统计范围" show-overflow-tooltip>
                        <template slot-scope="props">
                           {{ props.row.report_start_time || '--' }} - {{ props.row.report_end_time || '--' }}
                        </template>
                    </el-table-column>
                    <el-table-column prop="create_date" align="center" min-width="150" label="生成时间" show-overflow-tooltip>
                        <template slot-scope="props">
                           {{ props.row.create_date || '--' }}
                        </template>
                    </el-table-column>
                    <el-table-column prop="status" align="center" min-width="150" label="生成状态" show-overflow-tooltip>
                        <template slot-scope="props">
                           {{ props.row.status == 0? "正在生成中" : props.row.status == 1? "已生成" : "生成失败" }}
                        </template>
                    </el-table-column>
                    <el-table-column prop="status" label="操作" min-width="100">
                        <template slot-scope="scope">
                            <el-link type="primary" @click="openReportDialog(scope.row)">预览</el-link>
                            <el-link type="danger" @click="deleteReportById(scope.row)">删除</el-link>
                        </template>
                    </el-table-column>
                </el-table>
                <el-pagination
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="currentPage"
                    :page-sizes="[5,10, 20, 50]"
                    prev-text="上一页" next-text="下一页"
                    :page-size="size"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="total">
                </el-pagination>
            </div>
            </div>
            <div v-if="activeTab == 'chart'" id="bigimg" style="text-align:center;position:relative;">
                <img ref="bigImage" src="../../assets/3.svg"  @mousewheel="bagimg(this)"  @mousedown="move($event)"  alt="" style="position:relative;">
                <!-- <embed type="image/svg+xml" src="../../assets/1.svg" id="my-embed"/>            -->
            </div>
        </div>
        <addReport :visible.sync="dialogVisible" :treeData="treeData" @generate="handleChildGenerate" ></addReport>
        <!-- 引入报告生成弹窗 -->
        <OperationReportDialog
        :visible.sync="showReportDialog"
        :default-config="customConfig"
        :basic-info="selectReportData"
        @close="handleDialogClose"
        />
        <OperationReportMechDialog
        :visible.sync="showReportMechDialog"
        :default-config="customConfig"
        :basic-info="selectReportData"
        @close="handleDialogClose"
        />
    </div>

</template>

<script>
import * as device from '@/data/device.js'
import * as report from '@/data/report.js'
import * as account from "@/data/api.js";
import tree from '@/components/tree.vue'
import Bus from "@/util/Bus.js";
export default {
    name: "",
    components:{
        tree,
        addReport:resolve => {require(['../report/addReport.vue'], resolve)},
        OperationReportDialog:resolve => {require(['../report/OperationReportDialog.vue'], resolve)},
        OperationReportMechDialog:resolve => {require(['../report/OperationReportMechDialog.vue'], resolve)},
    },
    data() {
        return {
            showReportDialog: false,
            showReportMechDialog: false,
            // // 自定义报告配置（可选）
            customConfig: {
                title: '电力设备状态在线监测系统',
                company: 'XX电力有限公司',  
                siteName: 'XX变电站',
                timeRange: '2024-01-01 至 2024-12-31'
            },
            dataRange: [],
            isFold:false,
            isFoldClass:'el-icon-s-fold',

            isDefaultExpandFirst: true,
            treeData: [],
            tableData: [] ,
            selectData:[],
            originTableData:[],
            form: {
                point_name: '',
                is_online: '',
                alarm_level: '',
                sensor_type: '',
            },
            activeTab:'list',
            dataDetails:{},
            selectedData:[], // 表格中选中的数据
            params:{
                zoomVal:1,left:0,top:0,currentX:0,currentY:0,flag:false,
            },
            filterText:'',
            showSearchBox:false,
            currentPage:1,
            size:10,
            total:0,
            currentNode:{},//操作分页组件时需要知道之前点击的是哪个node
            loading:false,
            currentKey: '',//树的当前高亮点
            maxSelectionLimit: 6,
            isSelectAll: false,
            dialogVisible: false,

            exportLoading: false, // 导出加载状态
            dynamicHtml: '', // 动态生成的HTML内容
            // 存储后端请求的所有数据
            // reportData: {
            //     basicInfo: {}, // 基础信息
            //     assetList: [], // 资产列表（动态长度）
            //     alarmList: [], // 报警列表（动态长度）
            //     deviceData: [] // 设备数据（动态长度）
            // },
            siteList: [],
            searchForm: {
                "customer_id": "",
                "site_ids": "",
                "start_time": "",
                "end_time": "",
                "status": ""
            },
            currentNodeInfo: {},
            statusList: [
                {name: '生成中',value: 0},
                {name: '已生成',value: 1},
                {name: '生成失败',value: 2},
            ],
            reportList: [],
            selectReportData: {}
        };
    },
    watch: {
      filterText(val) {
        this.$refs.trees.filterData(val);
        },
    },
    mounted() {
        const loading = this.$loading({
            lock: true,
            text: 'Loading',
            spinner: 'el-icon-loading',
            background: 'rgba(0, 0, 0, 0.7)'
        });

        try {
            // 假设 getTreeData 是异步操作（如接口请求），用 await 等待完成
            this.getTreeData();
            this.getReportList();
            this.getSiteList()
            Bus.$on('wsData', this.wsDataBySite)
        } catch (error) {
            // 可添加错误提示：this.$message.error('加载失败，请重试')
        } finally {
            // 无论成功/失败，最终都关闭 loading
            if (loading && typeof loading.close === 'function') {
            loading.close();
            }
        }
    },
    beforeDestroy() {
        // 注销事件监听器
        Bus.$off('wsData', this.wsDataBySite);
    },
    methods: {
        handleChildGenerate(childData) {
            this.getReportList();
        },
        openReportDialog(row) {
            this.selectReportData = row;
            if (row.is_mech == true) {
                this.showReportMechDialog = true
            } else {
                this.showReportDialog = true;
            }
            
        },
        getSiteList(){
            account.siteRequest(this.searchForm.customer_id,'get').then(res=>{
                this.siteList = res.data.sites;
            })
        },
        deleteReportById(row) {
        this.$confirm("确认删除报告吗？删除后无法找回，需重新生成")
            .then(() => {
                report.deleteReport({customer_id: row.customer_id, data:{report_ids: [row.id]}}).then((res) => {
                    this.getReportList();
                }).catch((err) => {
                    console.log(err)
                    this.getReportList();
                })
            })
            .catch(() => {});
        },
        deleteReportByIds(row) {
            const selectedDataIds = this.selectedData.map(item => item.id)
            report.deleteReport({customer_id: row.customer_id, data:{report_ids: selectedDataIds}}).then((res) => {
                this.getReportList();
            }).catch((err) => {
                console.log(err)
                this.getReportList();
            })
        },
        getReportList() {
            // 确保treeData已加载
            if (this.treeData.length === 0) {
                this.getTreeData();
                return;
            }
            
            if (this.currentNodeInfo.type == 'customer') {
                this.searchForm.customer_id = this.currentNodeInfo.id;
            } else if(this.currentNodeInfo.type == 'site') {
                // 确保parent_id存在，如果不存在则尝试从缓存中获取
                if (this.currentNodeInfo.parent_id) {
                    this.searchForm.customer_id = this.currentNodeInfo.parent_id;
                } else {
                    // 尝试从缓存中获取完整的节点信息
                    const str = sessionStorage.getItem('currentNode');
                    if (str) {
                        const cachedNode = JSON.parse(str);
                        if (cachedNode.parent_id) {
                            this.searchForm.customer_id = cachedNode.parent_id;
                            // 更新currentNodeInfo
                            this.currentNodeInfo.parent_id = cachedNode.parent_id;
                        }
                    } 
                    
                    // 无论缓存中是否有数据，都从treeData中查找，确保准确性
                    if (this.treeData.length > 0) {
                        // 从treeData中查找父节点ID
                        let found = false;
                        for (let i = 0; i < this.treeData.length; i++) {
                            const customer = this.treeData[i];
                            if (customer.children) {
                                for (let j = 0; j < customer.children.length; j++) {
                                    const site = customer.children[j];
                                    if (site.id === this.currentNodeInfo.id) {
                                        this.searchForm.customer_id = customer.id;
                                        // 更新currentNodeInfo
                                        this.currentNodeInfo.parent_id = customer.id;
                                        found = true;
                                        break;
                                    }
                                }
                                if (found) break;
                            }
                        }
                    }
                }
            }
            // 确保customer_id存在，如果不存在则使用默认值
            if (!this.searchForm.customer_id && this.treeData.length > 0) {
                this.searchForm.customer_id = this.treeData[0].id;
            }
            this.searchForm.start_time = this.dataRange[0]
            this.searchForm.end_time = this.dataRange[1]
            report.getReportList({data: Object.assign(this.searchForm, { page: this.currentPage, limit: this.size })}).then((res) => {
                this.reportList = res.data.data
            }).catch((err) => {
                console.log("请求失败")
                console.log(err)
            })
        },
        handleDialogClose() {
            console.log('报告弹窗已关闭')
            // 可执行额外逻辑，如刷新数据、重置状态等
        },
        selectDate(){},
        handleClose(done) {
            this.$confirm('确认关闭？')
            .then(_ => {
                done();
            })
            .catch(_ => {});
        },
        wsDataBySite(target){
            target = JSON.parse(target);
            let sensorData = target.message.data.sensor_data;
            if(sensorData){
              //根据当前显示的列表做筛选，不是直接变更到列表中
              this.tableData.forEach((item,index) => {
                  if (item.sensor_number == sensorData.sensor_id) {
                      item.sensor_data_id=sensorData.sensor_data_id
                      if(sensorData.hasOwnProperty('is_online'))item.is_online = sensorData.is_online;
                      if(sensorData.hasOwnProperty('battery'))item.battery = sensorData.battery;
                      if(sensorData.hasOwnProperty('rssi'))item.rssi = sensorData.rssi;
                      if(sensorData.hasOwnProperty('snr'))item.snr = sensorData.snr;
                      if(sensorData.hasOwnProperty('alarm_level'))item.alarm_level = sensorData.alarm_level;
                      if(sensorData.hasOwnProperty('alarm_describe'))item.alarm_describe = sensorData.alarm_describe;
                      if(sensorData.hasOwnProperty('has_sensor_data'))item.has_sensor_data = sensorData.has_sensor_data;
                      if(sensorData.hasOwnProperty('character_value'))item.character_value = sensorData.character_value;
                      if(sensorData.hasOwnProperty('unit'))item.unit = sensorData.unit;
                      if(sensorData.hasOwnProperty('upload_interval'))item.upload_interval = sensorData.upload_interval;
                      if(sensorData.hasOwnProperty('create_date'))item.create_date = sensorData.create_date;
                  }
              })
            }
        },
        handleSizeChange(val){
             this.size = val;
             this.clickNode(this.currentNode)
        },
        handleCurrentChange(val){
            this.currentPage = val;
            this.clickNode(this.currentNode)
        },
        showSearch(){
            this.showSearchBox = !this.showSearchBox ;
        },
        toggle(){
            this.isFold = !this.isFold;
            let style = this.isFold?{width:'25px'}:{width:'280px'}
            let heightStyle = this.isFold?{height:'120px'}:{height:'calc(100% - 160px)'}
            let treeStyle = this.isFold?{height:0}:{height:"calc(100% - 40px)"}
            this.isFoldClass = this.isFold?'el-icon-s-unfold':'el-icon-s-fold'
            $('.left-tree').css(heightStyle).animate(style);
             $('.tree-div').css(treeStyle)
            this.isFold ? $('.main-area').css({ width: '100%' }) : $('.main-area').css({ width: 'calc(100% - 300px)' })
            this.showSearchBox = false
        },
        queryData() {
            this.clickNode(this.currentNode)
        },
        doReset(){
            this.$refs.from.resetFields();
            this.searchForm = {
                "customer_id": "",
                "site_ids": "",
                "start_time": "",
                "end_time": "",
                "status": ""
            }
            this.clickNode(this.currentNode)
            // this.restoreSelection()
        },
        handleSelectionChange(val) {
            // 记录当前是否为全选状态
            this.isSelectAll = val.length === this.tableData.length;
            // 当选择数量超过限制时
            if (val.length > this.maxSelectionLimit) {
                this.$nextTick(() => {
                    // 获取最新的选择数据
                    const latestSelection = [...this.$refs.multipleTable.selection];
                    // 截取前maxSelectionLimit个
                    const limitedSelection = latestSelection.slice(0, this.maxSelectionLimit);
                    
                    // 清除所有选择
                    this.$refs.multipleTable.clearSelection();
                    
                    // 重新选择前maxSelectionLimit个
                    limitedSelection.forEach(row => {
                        this.$refs.multipleTable.toggleRowSelection(row, true);
                    });
                    
                    // 更新选中数据
                    this.selectedData = limitedSelection;

                    // 提示用户
                    this.$message.closeAll(); 
                    this.$message.warning(`最多只能选择 ${this.maxSelectionLimit} 个测点`);
                });
            } else {
                // 未超过限制时，直接更新选中数据
                this.selectedData = val;
            }
        },   
        // 手动处理全选按钮点击事件
        handleSelectAll(val) {
            if(val===3){
                 val = this.tableData.slice(0, this.maxSelectionLimit)
                 val.forEach(row => {
                    this.$refs.multipleTable.toggleRowSelection(row,true);
                });
                this.selectedData =  val
                this.$message.warning(`最多只能选择 ${this.maxSelectionLimit} 个测点`);
            } else {
                this.$nextTick(() => {
                    // 如果当前是全选状态（或已选数量达到上限），则取消全选
                    if (this.isSelectAll || this.selectedData.length >= this.maxSelectionLimit) {
                        this.$refs.multipleTable.clearSelection();
                        this.selectedData = [];
                        this.isSelectAll = false;
                    } else {
                        // 否则选中前maxSelectionLimit个
                        const topItems = this.tableData.slice(0, this.maxSelectionLimit);

                        // 清除所有选择
                        this.$refs.multipleTable.clearSelection();

                        // 选择前maxSelectionLimit个
                        topItems.forEach(row => {
                            this.$refs.multipleTable.toggleRowSelection(row, true);
                        });

                        // 更新选中数据
                        this.selectedData = topItems;

                        // 如果数据总数超过限制，提示用户
                        if (this.tableData.length > this.maxSelectionLimit) {
                            this.$message.warning(`最多只能选择 ${this.maxSelectionLimit} 个测点`);
                        }

                        this.isSelectAll = topItems.length === this.tableData.length;
                    }
                });
            } 
        },
        // 无法勾选
        selectFun(row){
            if(!row.has_sensor_data){
                return false;
            }
            return true;
        },
        // 勾选
        handleSelect(val, row) {
            this.selectedData = val;
        },
        getTreeData(){            
            let This = this;
            device.queryTree().then(res=>{
                if(!res) return;
                This.treeData = res.data;
                const str = sessionStorage.getItem('currentNode');
                if (this.$route.params.searchForm) {
                    this.form = this.$route.params.searchForm
                }
                //来自综合统计双击进站点详情
                if (this.$route.params.obj) {
                    let obj = this.$route.params.obj;
                    // 确保站点对象有parent_id
                    if (obj.type == 'site' && !obj.parent_id) {
                        // 从treeData中查找父节点ID
                        for (let i = 0; i < res.data.length; i++) {
                            const customer = res.data[i];
                            if (customer.children) {
                                for (let j = 0; j < customer.children.length; j++) {
                                    const site = customer.children[j];
                                    if (site.id === obj.id) {
                                        obj.parent_id = customer.id;
                                        break;
                                    }
                                }
                            }
                        }
                    }
                    this.currentKey = obj.id
                    this.isDefaultExpandFirst = false
                    this.clickNode(obj)
                }else if (str) {
                    let obj = JSON.parse(str)
                    if(obj.type == 'customer'){
                         obj = obj.children[0]
                    }
                    this.currentKey = obj.id
                    this.isDefaultExpandFirst = false;
                    this.clickNode(obj)
                } else{
                  this.currentKey = res.data[0].children[0].id
                  this.clickNode(res.data[0].children[0])
                }
                this.$nextTick(() => {
                    this.$refs.trees.$refs.tree.setCurrentKey(this.currentKey);
                });
            })
        },
       
        // 树型点击事件
        clickNode(v) {
            this.currentPage = 1
            this.clickNodeTree(v)

            this.currentPage = 1;
            let obj;
            if (!v) {
                obj = this.currentNodeInfo
            } else {
                obj = v;
                this.currentNodeInfo = v;
            }
            this.currentKey = obj.id
            this.getReportList();
            this.getSiteList();
        },
        clickNodeTree(v) {
            this.currentNode = v;
            this.selectedData = [];
            this.currentKey = v.id
        },
        // 点击mark
        clickMark(node){
            this.$router.replace({ name: 'warning', params: { node: node } });
        },
       bagimg() {
            /* 获取当前页面的缩放比
                    若未设置zoom缩放比，则为默认100%，即1，原图大小
                */
            var zoom = parseInt(this.$refs.bigImage.style.zoom) || 100;
            /* event.wheelDelta 获取滚轮滚动值并将滚动值叠加给缩放比zoom
                    wheelDelta统一为±120，其中正数表示为向上滚动，负数表示向下滚动
                */
            zoom += event.wheelDelta / 12;
            /* 最小范围 和 最大范围 的图片缩放尺度 */
            // if (zoom >= 100 && zoom <250) {
                this.$refs.bigImage.style.zoom = zoom + "%";
            // }
            return false;
        },
        move(e){
            let odiv = e.target;        //获取目标元素
            //阻止默认事件的方法,如果不阻止默认事件onmouseup会无法触发
             e.preventDefault();
            //算出鼠标相对元素的位置
            let disX = (e.clientX - odiv.offsetLeft);
            let disY = (e.clientY - odiv.offsetTop);
            document.onmousemove = (e)=>{
                 //鼠标按下并移动的事件
                //用鼠标的位置减去鼠标相对元素的位置，得到元素的位置
                //因为img居中对齐，所以还要减去目标元素距离body的偏移量
                let left = e.clientX - disX - odiv.offsetLeft;
                let top = e.clientY - disY;
                //移动当前元素
                odiv.style.left = left + 'px';
                odiv.style.top = top + 'px';
            };
            document.onmouseup = (e) => {
                document.onmousemove = null;
                document.onmouseup = null;
            };
        },
    },
}
</script>

<style lang='less' scoped>
.left-tree{
    background: #2C2E30;color:#fff;float:left;height:calc(100% - 160px);
    .el-input{
        text-align: center;
        padding:5px 0;
    }
    /deep/.el-input__inner{
        background-color: rgb(44,46,48);
    }
}
.site-tabs{
    position: relative;
    /deep/.el-tabs{
        width:220px;position: absolute;left:0;right:0;margin:auto;top:0;
    }
    /deep/.el-tabs__nav-wrap::after{
        height:0;
    }
    /deep/.el-tabs__active-bar{
        height: 0;;
    }
}
 .small-btn{
        height:36px;background:rgb(32, 52, 49);border:solid 1px rgb(121,121,121);color:#fff;
        border-radius: 5px;
        cursor: pointer;
    }
    /deep/.left-tree .el-tree{
    background: #2C2E30;color:#fff;user-select: none;
}
/deep/.site-tabs-ul .el-tabs__item{
    font-size: 18px;;
}
/deep/.el-table tbody tr:hover>td{
    background: #3d3f44 !important;
}
/* 更改高亮颜色 */
/deep/.el-table__body tr.current-row>td.el-table__cell{
  background: #3d3f44 !important;
}
.table-btn{
    // color:#f00;
    // text-decoration: underline;
    // a{
    //     color:#f00;
    // }
}
.main-area{
    width:calc(100% - 300px);
    float: right;
}
/deep/.el-button+.el-button{
    margin-left:0;
}
.table-content{
    height:calc(100% - 150px);
    overflow: hidden;
    position: relative;
    .device-name,.point-name{
        width:150px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }
    /deep/.cell {
        white-space: nowrap;
    }
    /deep/.el-table{
        height: calc(100% - 50px) !important;
        overflow: hidden;
    }
    /deep/.el-table__body-wrapper{
        height: calc(100% - 50px);
        overflow-y: auto;
    }
}
/deep/.el-pagination {
    position: absolute;text-align: center;
    bottom: 0;left:0;right:0;margin:0 auto;
    .el-input__inner{
        background: #2C2E30;
        border:0;color:#fff;
    }
    .btn-prev,.btn-next{
        background: #2C2E30;
    }
    .el-pager li{
         background: #2C2E30;
    }
}
.tree-div{
    height:calc(100% - 40px)
}
/deep/.el-loading-text{color:#fff;}

.selected-border /deep/.el-input__inner {
  border: 1px solid #409EFF !important; /* 蓝色边框 */
  border-radius: 4px; /* 圆角 */
}
.alarmLevel_p {
    width: 50px;
    margin-left:35px
}
.sensor_type_p{
    width: 100px;
    margin-left:45px
}
.sensor_status{
    width: 13x;
    height: 13px;
    float: left;
    margin-left:20px;
    margin-top:4px;
}
/deep/.el-input__inner{
  color: #ffffff;
}
.status-container {
  display: flex;
  flex-direction: column;
  gap: 4px; /* 内部元素垂直间距 */
  align-items: center; /* 水平居中 */
}

.status-icon {
  width: 13px;
  height: 13px;
  margin-right: 4px;
}

.online-text {
  margin-bottom: 2px;
}
.online-text-alarmStatus {
  margin-bottom: 2px;
  width:50px
}
.metrics-info {
  display: flex;
  flex-wrap: wrap; /* 空间不足时自动换行 */
  gap: 8px; /* 指标项之间的间距 */
  justify-content: center; /* 水平居中 */
  width: 100%; /* 占满单元格宽度 */
  font-size:10px
}

.metric-item {
  display: flex;
  align-items: center;
  gap: 4px; /* 图标与文本间距 */
}

.metric-icon {
  width: 15px;
  height: 15px;
}
/* 新增：控制图标和文本在同一行 */
.status-header {
  display: flex; /* 水平排列 */
  align-items: center; /* 垂直居中对齐 */
  gap: 6px; /* 图标与文本之间的间距 */
}
/deep/.el-date-editor .el-range-input {
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    border: none;
    outline: 0;
    padding: 0;
    width: 39%;
    background-color: rgb(44, 46, 48);
}
// @keyframes intermittentShake {
//   /* 0-1秒：快速抖动 */
//   0%, 5%, 10%, 15% { transform: translateX(-3px); }
//   2.5%, 7.5%, 12.5%, 17.5% { transform: translateX(3px); }
//   /* 1-3秒：静止不动（暂停抖动） */
//   20% { transform: translateX(0); }

// }

// /* 应用动画的类 */
// .intermittent-shake {
//   /* 总周期3秒（1秒抖动 + 2秒静止），无限循环 */
//   animation: intermittentShake 3s cubic-bezier(.36,.07,.19,.97) infinite;
//   transform-origin: center;
// }
</style>



// WEBPACK FOOTER //
// src/view/report/exportReport.vue